import DefaultArticleTeaser from '@/components/content/ArticleTeaser';
import { StandaloneArticleTeaser } from '@/components/content/ArticleTeaser/Default';
import { LabradorComponent } from '@/types/component';
import { withDebugMetadata } from 'lib/utils';

const MotherhoodArticleTeaser: LabradorComponent = ({ type, data, meta, descendants }) => {
  if (data.category === '_default') {
    data.category = 'mammaliv';
  }

  data.subtitle = undefined;

  return <DefaultArticleTeaser {...{ type, data, meta, descendants }} {...withDebugMetadata({ type, meta })} />;
};

export const standalone = StandaloneArticleTeaser;

export default MotherhoodArticleTeaser;
